webpackJsonp([1],{

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__(1133);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

var atob = __webpack_require__(1134);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),

/***/ 1134:
/***/ (function(module, exports) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),

/***/ 1135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Header__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Search__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Results__ = __webpack_require__(1137);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */


// import { connect } from 'react-redux';
// import checkoutReducer, { actions } from 'modules/checkout';
// import adminReducer, { actions as adminActions } from 'modules/admin';






var Refunds = function (_PureComponent) {
  _inherits(Refunds, _PureComponent);

  function Refunds() {
    _classCallCheck(this, Refunds);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  Refunds.prototype.componentDidMount = function componentDidMount() {
    window.onbeforeunload = function () {
      return false;
    };
  };

  Refunds.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default.a,
      { container: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Header__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_Search__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_Results__["a" /* default */], null)
    );
  };

  return Refunds;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var _default = Refunds;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Refunds, 'Refunds', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/index.jsx');
}();

;

/***/ }),

/***/ 1136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Search */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Button__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_admin__ = __webpack_require__(390);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var muiThemeStyles = function muiThemeStyles(theme) {
  return {
    textField: theme.textField,
    button: theme.button,
    Input: theme.Input,
    input: theme.input
  };
};

var Search = function (_PureComponent) {
  _inherits(Search, _PureComponent);

  function Search() {
    var _temp, _this, _ret;

    _classCallCheck(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.handleInputOrderId = function () {
      var _this2;

      return (_this2 = _this).__handleInputOrderId__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleInputUserEmailSearchText = function () {
      var _this3;

      return (_this3 = _this).__handleInputUserEmailSearchText__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _this.handleInputUserFirstNameSearchText = function () {
      var _this4;

      return (_this4 = _this).__handleInputUserFirstNameSearchText__REACT_HOT_LOADER__.apply(_this4, arguments);
    }, _this.handleInputUserLastNameSearchText = function () {
      var _this5;

      return (_this5 = _this).__handleInputUserLastNameSearchText__REACT_HOT_LOADER__.apply(_this5, arguments);
    }, _this.handleKeyDown = function () {
      var _this6;

      return (_this6 = _this).__handleKeyDown__REACT_HOT_LOADER__.apply(_this6, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Search.prototype.__handleInputOrderId__REACT_HOT_LOADER__ = function __handleInputOrderId__REACT_HOT_LOADER__(e) {
    this.props.updateOrderIdSearchText(e.target.value.replace(/\D+/g, ''));
  };

  Search.prototype.__handleInputUserEmailSearchText__REACT_HOT_LOADER__ = function __handleInputUserEmailSearchText__REACT_HOT_LOADER__(e) {
    this.props.updateUserEmailSearchText(e.target.value);
  };

  Search.prototype.__handleInputUserFirstNameSearchText__REACT_HOT_LOADER__ = function __handleInputUserFirstNameSearchText__REACT_HOT_LOADER__(e) {
    this.props.updateUserFirstNameSearchText(e.target.value);
  };

  Search.prototype.__handleInputUserLastNameSearchText__REACT_HOT_LOADER__ = function __handleInputUserLastNameSearchText__REACT_HOT_LOADER__(e) {
    this.props.updateUserLastNameSearchText(e.target.value);
  };

  Search.prototype.__handleKeyDown__REACT_HOT_LOADER__ = function __handleKeyDown__REACT_HOT_LOADER__(e) {
    if (e.charCode === 13) {
      this.props.search();
    }
  };

  Search.prototype.render = function render() {
    var _props = this.props,
        classes = _props.classes,
        errorMessage = _props.errorMessage,
        loading = _props.loading,
        orderIdSearchText = _props.orderIdSearchText,
        userEmailSearchText = _props.userEmailSearchText,
        userFirstNameSearchText = _props.userFirstNameSearchText,
        userLastNameSearchText = _props.userLastNameSearchText;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
      { item: true, xs: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
        { variant: 'headline' },
        'Refunds: Search by Order Id, Email or User Name'
      ),
      errorMessage.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,
        { variant: 'body1', style: { color: 'red' } },
        errorMessage
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
        { container: true, direction: 'column', spacing: 0, style: { margin: '16px 0' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            inputProps: { className: classes.input, id: 'orderId' },
            name: 'orderId',
            placeholder: 'Order ID',
            value: orderIdSearchText,
            onChange: this.handleInputOrderId,
            onKeyPress: this.handleKeyDown
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            inputProps: { className: classes.input, id: 'userEmail' },
            name: 'userEmail',
            placeholder: 'Email',
            value: userEmailSearchText,
            onChange: this.handleInputUserEmailSearchText,
            onKeyPress: this.handleKeyDown
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            inputProps: { className: classes.input, id: 'firstName' },
            placeholder: 'First Name',
            name: 'firstName',
            value: userFirstNameSearchText,
            onChange: this.handleInputUserFirstNameSearchText,
            onKeyPress: this.handleKeyDown
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
            className: classes.textField,
            InputProps: { className: classes.Input },
            inputProps: { className: classes.input, id: 'lastName' },
            placeholder: 'Last Name',
            name: 'lastName',
            value: userLastNameSearchText,
            onChange: this.handleInputUserLastNameSearchText,
            onKeyPress: this.handleKeyDown
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_Button___default.a,
          {
            color: 'primary',
            disabled: loading,
            onClick: this.props.search
          },
          'Search'
        )
      )
    );
  };

  return Search;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Search.propTypes = {
  classes: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({}).isRequired,
  errorMessage: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,
  orderIdSearchText: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  userEmailSearchText: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  userFirstNameSearchText: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  userLastNameSearchText: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  updateOrderIdSearchText: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  updateUserEmailSearchText: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  updateUserFirstNameSearchText: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  updateUserLastNameSearchText: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  search: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loading: state.admin.loading,
    errorMessage: state.admin.errorMessage,
    orderIdSearchText: state.admin.orderIdSearchText,
    userEmailSearchText: state.admin.userEmailSearchText,
    userFirstNameSearchText: state.admin.userFirstNameSearchText,
    userLastNameSearchText: state.admin.userLastNameSearchText
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateOrderIdSearchText: function updateOrderIdSearchText(text) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_admin__["a" /* actions */].updateOrderIdSearchText(text));
    },
    updateUserEmailSearchText: function updateUserEmailSearchText(text) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_admin__["a" /* actions */].updateUserEmailSearchText(text));
    },
    updateUserFirstNameSearchText: function updateUserFirstNameSearchText(text) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_admin__["a" /* actions */].updateUserFirstNameSearchText(text));
    },
    updateUserLastNameSearchText: function updateUserLastNameSearchText(text) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_admin__["a" /* actions */].updateUserLastNameSearchText(text));
    },
    search: function search() {
      dispatch(__WEBPACK_IMPORTED_MODULE_8_modules_admin__["a" /* actions */].search());
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__["withStyles"])(muiThemeStyles)(Search));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(muiThemeStyles, 'muiThemeStyles', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Search/index.jsx');

  __REACT_HOT_LOADER__.register(Search, 'Search', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Search/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Search/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Search/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Search/index.jsx');
}();

;

/***/ }),

/***/ 1137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Results */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Button__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Progress__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_routes_Orders_components_RefundOrder__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PageNumbers__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_user__ = __webpack_require__(124);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Results = function (_PureComponent) {
  _inherits(Results, _PureComponent);

  function Results() {
    _classCallCheck(this, Results);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  Results.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        currentPage = _props.currentPage,
        loading = _props.loading,
        pageSize = _props.pageSize,
        results = _props.results,
        savedUserEmailSearchText = _props.savedUserEmailSearchText,
        savedOrderIdSearchText = _props.savedOrderIdSearchText,
        savedUserFirstNameSearchText = _props.savedUserFirstNameSearchText,
        savedUserLastNameSearchText = _props.savedUserLastNameSearchText,
        totalResults = _props.totalResults;


    if (loading) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Progress__["CircularProgress"], { style: { marginLeft: '60px' }, color: 'primary' });
    }

    var resultsLength = totalResults;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default.a,
      { item: true, xs: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default.a,
        { container: true, spacing: 0, direction: 'column', style: { backgroundColor: '#d3d3d3', padding: '16px' } },
        savedOrderIdSearchText.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography___default.a,
          { variant: 'headline' },
          'Order Id: ',
          savedOrderIdSearchText
        ) : null,
        savedUserEmailSearchText.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography___default.a,
          { variant: 'headline' },
          'Email: ',
          savedUserEmailSearchText
        ) : null,
        savedUserFirstNameSearchText.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography___default.a,
          { variant: 'headline' },
          'First Name: ',
          savedUserFirstNameSearchText
        ) : null,
        savedUserLastNameSearchText.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography___default.a,
          { variant: 'headline' },
          'Last Name: ',
          savedUserLastNameSearchText
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography___default.a,
          { variant: 'headline' },
          'Total Results: ',
          resultsLength
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_PageNumbers__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default.a,
        { item: true, xs: 12, style: { margin: '16px 0' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default.a,
          {
            onClick: function onClick() {
              return _this2.props.logoutUser();
            }
          },
          'Logout'
        )
      ),
      results && results.map(function (order, i) {
        if (order) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_routes_Orders_components_RefundOrder__["a" /* default */], { key: i, resultNum: currentPage * pageSize + i + 1, order: order });
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_PageNumbers__["a" /* default */], null),
      results && results.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default.a,
        { item: true, xs: 12, style: { margin: '16px 0' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default.a,
          {
            onClick: function onClick() {
              return _this2.props.logoutUser();
            }
          },
          'Logout'
        )
      ) : null
    );
  };

  return Results;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Results.propTypes = {
  currentPage: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  pageSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,
  results: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired
  })),
  savedUserEmailSearchText: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  savedOrderIdSearchText: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  savedUserFirstNameSearchText: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  savedUserLastNameSearchText: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  totalResults: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired
};

Results.defaultProps = {
  results: []
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentPage: state.admin.currentPage,
    logoutUser: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    loading: state.admin.loading,
    pageSize: state.admin.pageSize,
    results: state.admin.results,
    savedUserEmailSearchText: state.admin.savedUserEmailSearchText,
    savedOrderIdSearchText: state.admin.savedOrderIdSearchText,
    savedUserFirstNameSearchText: state.admin.savedUserFirstNameSearchText,
    savedUserLastNameSearchText: state.admin.savedUserLastNameSearchText,
    totalResults: state.admin.totalResults
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    logoutUser: function logoutUser() {
      dispatch(__WEBPACK_IMPORTED_MODULE_9_modules_user__["a" /* actions */].logoutUser());
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Results);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Results, 'Results', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Results/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Results/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Results/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Results/index.jsx');
}();

;

/***/ }),

/***/ 1138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RefundOrder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Button__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_admin__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_user__ = __webpack_require__(124);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/jsx-no-duplicate-props */










var RefundOrder = function (_Component) {
  _inherits(RefundOrder, _Component);

  function RefundOrder() {
    var _temp, _this, _ret;

    _classCallCheck(this, RefundOrder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleClickRefund = function () {
      var _this2;

      return (_this2 = _this).__handleClickRefund__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleClickResendReceipt = function () {
      var _this3;

      return (_this3 = _this).__handleClickResendReceipt__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  RefundOrder.prototype.__handleClickRefund__REACT_HOT_LOADER__ = function __handleClickRefund__REACT_HOT_LOADER__(id, firstName) {
    var orderDetails = 'Order number: ' + id + ' for ' + firstName;
    var refundConfirmed = window.prompt('To confirm, please type \'refund\' to refund ' + orderDetails);
    if (refundConfirmed === 'refund') {
      this.props.refundOrder(id);
    }
  };

  RefundOrder.prototype.__handleClickResendReceipt__REACT_HOT_LOADER__ = function __handleClickResendReceipt__REACT_HOT_LOADER__(id) {
    if (this.props.order.receiptSent) {
      var resendReceiptAgain = window.confirm('Are you sure you want to resend receipt again?');
      if (resendReceiptAgain) {
        this.props.resendReceipt(id);
      }
    } else {
      this.props.resendReceipt(id);
    }
  };

  RefundOrder.prototype.render = function render() {
    var _this4 = this;

    var _props$order = this.props.order,
        createdAt = _props$order.createdAt,
        gift = _props$order.gift,
        id = _props$order.id,
        _props$order$User = _props$order.User,
        email = _props$order$User.email,
        firstName = _props$order$User.firstName,
        lastName = _props$order$User.lastName,
        name = _props$order.Offer.name,
        OrderProducts = _props$order.OrderProducts,
        OrderTransactions = _props$order.OrderTransactions,
        receiptSent = _props$order.receiptSent,
        refunded = _props$order.refunded,
        total = _props$order.total;


    var backgroundColor = void 0;
    var resultNum = this.props.resultNum;


    if (resultNum % 2 !== 0) {
      backgroundColor = '#f4fbf3';
    }

    if (refunded) {
      backgroundColor = '#ffcc80';
    }

    var noRefundText = void 0;
    var refundsAllowed = !gift && OrderTransactions[0].gateway !== 'manual';
    if (!refundsAllowed) {
      noRefundText = 'No refunds for gifts or free orders';
    } else {
      //already refunded or null
      noRefundText = refunded;
    }

    var products = OrderProducts.filter(function (product) {
      return !product.UpSellId && !product.BumpOfferId;
    });
    var upsells = OrderProducts.filter(function (product) {
      return !!product.UpSellId;
    });
    var bumpOffers = OrderProducts.filter(function (product) {
      return !!product.BumpOfferId;
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
      { item: true, xs: 12, style: { backgroundColor: backgroundColor, paddingTop: '16px', paddingLeft: '16px', paddingBottom: '16px' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
        { container: true, spacing: 0 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 9 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
            { container: true, direction: 'row', spacing: 0 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
              { item: true, xs: 1 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                null,
                resultNum
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
              { item: true, xs: 11 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                { container: true, direction: 'column', spacing: 0 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                  { container: true, spacing: 0 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      'Date:'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 8 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      createdAt.slice(0, 10)
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                  { container: true, spacing: 0 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      'Order ID:'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 8 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      id
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                  { container: true, spacing: 0 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      'First name:'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 8 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      firstName
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                  { container: true, spacing: 0 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      'Last name:'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 8 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      lastName
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                  { container: true, spacing: 0 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      'Email:'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 8 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      { style: { wordWrap: 'break-word' } },
                      email
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                  { container: true, spacing: 0 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      'Offer:'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 8 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      name
                    )
                  )
                ),
                bumpOffers.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                  { container: true, spacing: 0 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      'Bump Offer IDs:'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 8 },
                    bumpOffers.map(function (bumpOffer, i) {
                      var hackyIndex = i + 100;
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                        { key: hackyIndex, style: { paddingRight: '16px', display: 'inline-block' } },
                        bumpOffer.id
                      );
                    })
                  )
                ) : null,
                upsells.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                  { container: true, spacing: 0 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      'Upsell IDs:'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 8 },
                    upsells.map(function (upsell, i) {
                      var hackyIndex2 = i + 100;
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                        { key: hackyIndex2, style: { paddingRight: '16px', display: 'inline-block' } },
                        upsell.id
                      );
                    })
                  )
                ) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                  { container: true, spacing: 0 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      'Order total:'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { item: true, xs: 8 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                      null,
                      '' + total
                    )
                  )
                ),
                products.map(function (product, i) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                    { key: i, container: true, spacing: 0 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                      { item: true, xs: 4 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                        null,
                        'Product: '
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
                      { item: true, xs: 8 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                        null,
                        product.Product.name
                      )
                    )
                  );
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
            { container: true, justify: 'flex-end', spacing: 0, direction: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
              { item: true, xs: 12 },
              !refunded && refundsAllowed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default.a,
                {
                  onClick: function onClick() {
                    return _this4.handleClickRefund(id, firstName);
                  }
                },
                'Click to refund'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                { style: { paddingRight: '16px' } },
                'Refunded Status: ',
                noRefundText
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
              { item: true, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default.a,
                {
                  onClick: function onClick() {
                    return _this4.handleClickResendReceipt(id);
                  }
                },
                'Click to resend receipt'
              ),
              receiptSent ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                { style: { paddingRight: '16px' } },
                'Resent: ' + receiptSent
              ) : null
            )
          )
        )
      )
    );
  };

  return RefundOrder;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RefundOrder.propTypes = {
  refundOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resendReceipt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resultNum: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  order: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    createdAt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    gift: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([null, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    User: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      firstName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      lastName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }).isRequired,
    Offer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }).isRequired,
    OrderProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,
    OrderTransactions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,
    receiptSent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    refunded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    total: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    logoutUser: function logoutUser() {
      dispatch(__WEBPACK_IMPORTED_MODULE_7_modules_user__["a" /* actions */].logoutUser());
    },
    resendReceipt: function resendReceipt(id) {
      dispatch(__WEBPACK_IMPORTED_MODULE_6_modules_admin__["a" /* actions */].resendReceipt(id));
    },
    refundOrder: function refundOrder(id) {
      dispatch(__WEBPACK_IMPORTED_MODULE_6_modules_admin__["a" /* actions */].refundOrder(id));
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null, mapDispatchToProps)(RefundOrder);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RefundOrder, 'RefundOrder', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/components/RefundOrder/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/components/RefundOrder/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/components/RefundOrder/index.jsx');
}();

;

/***/ }),

/***/ 1139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Search */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Button__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_admin__ = __webpack_require__(390);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Search = function (_PureComponent) {
  _inherits(Search, _PureComponent);

  function Search() {
    var _temp, _this, _ret;

    _classCallCheck(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.nextPage = function () {
      var _this2;

      return (_this2 = _this).__nextPage__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.previousPage = function () {
      var _this3;

      return (_this3 = _this).__previousPage__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Search.prototype.__nextPage__REACT_HOT_LOADER__ = function __nextPage__REACT_HOT_LOADER__() {
    var _props = this.props,
        currentPage = _props.currentPage,
        totalPages = _props.totalPages;

    var nextPage = void 0;
    if (currentPage + 1 < totalPages) {
      nextPage = currentPage + 1;
      this.props.search(nextPage);
    }
  };

  Search.prototype.__previousPage__REACT_HOT_LOADER__ = function __previousPage__REACT_HOT_LOADER__() {
    var currentPage = this.props.currentPage;

    var previousPage = void 0;
    if (currentPage > 0) {
      previousPage = currentPage - 1;
      this.props.search(previousPage);
    }
  };

  Search.prototype.render = function render() {
    var _props2 = this.props,
        currentPage = _props2.currentPage,
        results = _props2.results,
        totalPages = _props2.totalPages;


    if (totalPages <= 1) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default.a,
      { item: true, xs: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default.a,
        { container: true, spacing: 0, style: { padding: '16px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default.a,
          { item: true, xs: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Typography___default.a,
            { variant: 'headline' },
            'Page ',
            currentPage + 1,
            ' of ',
            totalPages,
            ' '
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default.a,
          { item: true, xs: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_Grid___default.a,
            { container: true, spacing: 0, justify: 'flex-end' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default.a,
              {
                onClick: this.previousPage,
                disabled: currentPage === 0
              },
              'Previous Page'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default.a,
              {
                onClick: this.nextPage,
                disabled: currentPage + 1 >= totalPages
              },
              'Next Page'
            )
          )
        )
      )
    );
  };

  return Search;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Search.propTypes = {
  currentPage: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
  results: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({})).isRequired,
  search: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  totalPages: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentPage: state.admin.currentPage,
    results: state.admin.results,
    totalPages: state.admin.totalPages
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    search: function search(pageNumber) {
      dispatch(__WEBPACK_IMPORTED_MODULE_6_modules_admin__["a" /* actions */].search(pageNumber));
    }
  };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Search);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Search, 'Search', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Results/components/PageNumbers/index.jsx');

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Results/components/PageNumbers/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Results/components/PageNumbers/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/Refunds/containers/Results/components/PageNumbers/index.jsx');
}();

;

/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Header__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Refunds__ = __webpack_require__(1135);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */





// import checkoutReducer, { actions } from 'modules/checkout';




var Orders = (_dec = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    user: state.user
  };
}), _dec(_class = function (_PureComponent) {
  _inherits(Orders, _PureComponent);

  function Orders(props) {
    _classCallCheck(this, Orders);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    var isCS = false;
    var _props$user = props.user,
        authToken = _props$user.authToken,
        isAuthenticated = _props$user.isAuthenticated;


    if (isAuthenticated && authToken) {
      var decodedToken = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(authToken);
      if (decodedToken.role === 'cs' || decodedToken.role === 'admin') {
        isCS = true;
      }
    }

    _this.state = { isCS: isCS };
    return _this;
  }

  Orders.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var wasAuthenticated = this.props.user.isAuthenticated;
    var isAuthenticatedNow = nextProps.user.isAuthenticated;
    var authTokenPresentNow = !!nextProps.user.authToken;

    if (!wasAuthenticated && isAuthenticatedNow && authTokenPresentNow) {
      this.setIsCS(nextProps.user.authToken);
    }
  };

  Orders.prototype.setIsCS = function setIsCS(authToken) {
    var decodedToken = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(authToken);
    if (decodedToken.role === 'cs' || decodedToken.role === 'admin') {
      this.setState({ isCS: true });
    }
  };

  Orders.prototype.render = function render() {
    var isCS = this.state.isCS;
    var isAuthenticated = this.props.user.isAuthenticated;


    if (!isCS || !isAuthenticated) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Header__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
          null,
          'Please log in - customer service.'
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Switch */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Route */], { path: '/orders/refunds', component: __WEBPACK_IMPORTED_MODULE_6__Refunds__["a" /* default */] })
    );
  };

  return Orders;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"])) || _class);
var _default = Orders;


/* harmony default export */ __webpack_exports__["default"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Orders, 'Orders', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/markromero/Code/frn-platform-frontend/src/routes/Orders/containers/index.jsx');
}();

;

/***/ })

});


// WEBPACK FOOTER //
// orders-a8b63222.js